import React from 'react';
import { Typography, IconButton } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import './NavigationButtons.css';
import imgMap from '../imgExporter';

const NavigationButtons = ({ onBack, activeStep, title, imageKey }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (activeStep === 0) {
      navigate(-1);
    } else if (onBack) {
      onBack();
    }
  };

  const imageSrc = imgMap[imageKey];

  return (
    <div className="gri-header-container">
      <IconButton
        className="back-button"
        aria-label="back"
        onClick={handleBack}
      >
        <ArrowBackIcon />
      </IconButton>

      {imageSrc && (
        <img
          src={imageSrc}
          alt={`${title} logo`}
          className="gri-header-image"
        />
      )}

      <Typography variant="h5" className="gri-title">
        {title}
      </Typography>
    </div>
  );
};

export default NavigationButtons;
